// Auto-generated per-query builders for Organisation
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { OrganisationReadAPI, OrganisationWriteAPI, OrganisationReadAPISchema, OrganisationWriteAPISchema } from '../types/organisation';
import { ModelRegistry } from '../../registries/model-registry';
import { GitHubRepoOfOrganisation, GroupAt, Owns, ParentScope } from '../../relationships/relationship';

import { Group } from './group';
import { SecurityScope } from '../../shared/api/securityscope';
import { Workspace } from './workspace';
import { GitHubRepo } from '../../rflp/api/githubrepo';



// Field names for order_by on Organisation
type OrganisationFields = "created_at" | "-created_at" | "name" | "-name";


// Include spec for query: BaseAllOrganisationsIncludeSpec
export interface BaseAllOrganisationsIncludeSpec {
  groups?: {
    holders?: {
    };
  };
}

// Include spec for query: BaseOrganisationByIdIncludeSpec
export interface BaseOrganisationByIdIncludeSpec {
  groups?: {
    holders?: {
    };
  };
}


// Builder chain for query: base-all-organisations

export interface BaseAllOrganisationsBuilder_0 {
  orderBy(field?: OrganisationFields): BaseAllOrganisationsBuilder_0;
}

export interface BaseAllOrganisationsBuilder_0 {
  limit(value?: number): BaseAllOrganisationsBuilder_0;
  load(include: BaseAllOrganisationsIncludeSpec): BaseAllOrganisationsBuilder_0;
  all(): Promise<Organisation[]>;
  first(): Promise<Organisation | null>;
  get(): Promise<Organisation[]>;
  execute(): Promise<Organisation[]>;
}

// Builder chain for query: base-organisation-by-id

export interface BaseOrganisationByIdBuilder_0 {
  get(id: string): BaseOrganisationByIdBuilder_1;
  filter(conditions: { id: string }): BaseOrganisationByIdBuilder_1;
}

export interface BaseOrganisationByIdBuilder_1 {
  load(include: BaseOrganisationByIdIncludeSpec): BaseOrganisationByIdBuilder_1;
  all(): Promise<Organisation[]>;
  first(): Promise<Organisation | null>;
  get(): Promise<Organisation[]>;
  execute(): Promise<Organisation[]>;
}


// Union of all query entry points
export type OrganisationQueryBuilder = BaseAllOrganisationsBuilder_0 | BaseOrganisationByIdBuilder_0;

// Available query names for .setQuery()
export type OrganisationQueryNames = "base-all-organisations" | "base-organisation-by-id";

// Type narrowing for .setQuery()
export type OrganisationBuilderForQuery<Q extends OrganisationQueryNames> =
  Q extends "base-all-organisations" ? BaseAllOrganisationsBuilder_0
  : Q extends "base-organisation-by-id" ? BaseOrganisationByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type OrganisationInstanceQueryResult<Q extends OrganisationQueryNames> =
  Q extends "base-all-organisations" ? BaseAllOrganisationsBuilder_0
  : Q extends "base-organisation-by-id" ? BaseOrganisationByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'order_by|limit': 'base-all-organisations',
  '': 'base-organisation-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends OrganisationQueryNames>(queryName: Q): OrganisationBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Organisation extends Partial<OrganisationReadAPI> {}
export class Organisation extends NeoNodeBase<OrganisationReadAPI, OrganisationWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Organisation";
  static readonly readSchema = OrganisationReadAPISchema;
  static readonly writeSchema = OrganisationWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    parent_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "ParentScope", direction: "out" },
    child_scopes: { target: "SecurityScope", cardinality: "many", isParent: false, relClass: "ParentScope", direction: "in" },
    groups: { target: "Group", cardinality: "many", isParent: false, relClass: "GroupAt", direction: "in" },
    workspaces: { target: "Workspace", cardinality: "many", isParent: false, relClass: "Owns", direction: "out" },
    github_repos: { target: "GitHubRepo", cardinality: "many", isParent: false, relClass: "GitHubRepoOfOrganisation", direction: "in" },
  };

  protected get modelName(): string {
    return 'Organisation';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Organisation.label;
  }


  constructor(data: Partial<OrganisationWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: OrganisationReadAPI, loadContext?: Record<string, any>): Organisation {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { groups, parent_scope, child_scopes, workspaces, github_repos, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = OrganisationReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, groups: groups, parent_scope: parent_scope, child_scopes: child_scopes, workspaces: workspaces, github_repos: github_repos };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Organisation.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'groups', 'Group', ModelRegistry);
    loadOneRelationship(processed, 'parent_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'child_scopes', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'workspaces', 'Workspace', ModelRegistry);
    loadManyRelationship(processed, 'github_repos', 'GitHubRepo', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Organisation(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): OrganisationQueryBuilder {
    return new QueryBuilderImpl('Organisation').filter(conditions) as any;
  }

  static all(): OrganisationQueryBuilder {
    return new QueryBuilderImpl('Organisation') as any;
  }

  static async first(): Promise<Organisation | null> {
    const results = await new QueryBuilderImpl('Organisation').execute();
    return results[0] || null;
  }


  static setQuery<Q extends OrganisationQueryNames>(queryName: Q): OrganisationBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Organisation');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends OrganisationQueryNames>(queryName: Q): OrganisationInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Organisation.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'groups' - Python ORM style (cached)
  get groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('groups', () => {
      return new RelationshipManager(this, 'groups', 'one', GroupAt as typeof Relationship);
    });
  }

  // Relationship manager for 'parent_scope' - Python ORM style (cached)
  get parent_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('parent_scope', () => {
      return new RelationshipManager(this, 'parent_scope', 'one', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'child_scopes' - Python ORM style (cached)
  get child_scopes(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('child_scopes', () => {
      return new RelationshipManager(this, 'child_scopes', 'many', ParentScope as typeof Relationship);
    });
  }

  // Relationship manager for 'workspaces' - Python ORM style (cached)
  get workspaces(): RelationshipManager<this, Workspace> {
    return this.getOrCreateRelationshipManager('workspaces', () => {
      return new RelationshipManager(this, 'workspaces', 'many', Owns as typeof Relationship);
    });
  }

  // Relationship manager for 'github_repos' - Python ORM style (cached)
  get github_repos(): RelationshipManager<this, GitHubRepo> {
    return this.getOrCreateRelationshipManager('github_repos', () => {
      return new RelationshipManager(this, 'github_repos', 'many', GitHubRepoOfOrganisation as typeof Relationship);
    });
  }

}
